import type { TranslatedString } from '@interfaces/shared';
import type {
  EmbeddedWorkflowResolutionStatus,
  WorkflowSubStepsDefinition,
} from '@ovComponents/4-module/goalCard/goalRiskQuestionConfig';
import { resolveReviewGoalRiskQuestionTitle } from '@ovComponents/4-module/goalCard/goalRiskQuestionConfig';
import type { WorkflowDataType } from '@ovComponents/4-module/workflowCompletion/workflowTypes';

export type ReviewGoalSubStepOptions = {
  goalWorkflow?: string;
  displayRiskAmount?: boolean;
  displayGoalTargetAmount?: boolean;
  displayTimeHorizon?: boolean;
  editGoal?: boolean;
  createAnotherGoal?: boolean;
  title?: TranslatedString;
  subtitle?: TranslatedString;
  [key: string]: unknown;
};

export type ReviewGoalCardOptions = ReviewGoalSubStepOptions & {
  timeHorizons?: WorkflowDataType['goalTimeHorizons'];
  riskQuestions?: WorkflowDataType['goalRiskQuestions'];
  riskQuestionTitle?: TranslatedString;
  riskQuestionTitlePending?: boolean;
};

export const buildReviewGoalCardOptions = (
  translateBackendString: (translatedObject: unknown) => string,
  {
    options,
    workflowData,
    embeddedWorkflow,
    embeddedWorkflowStatus,
  }: {
    options: ReviewGoalSubStepOptions;
    workflowData: Pick<
      WorkflowDataType,
      'goalTimeHorizons' | 'goalRiskQuestions' | 'goalRiskQuestionTitle'
    >;
    embeddedWorkflow?: WorkflowSubStepsDefinition | null;
    embeddedWorkflowStatus: EmbeddedWorkflowResolutionStatus;
  },
): ReviewGoalCardOptions => {
  const { riskQuestionTitle, riskQuestionTitlePending } =
    resolveReviewGoalRiskQuestionTitle(translateBackendString, {
      sessionTitle: workflowData.goalRiskQuestionTitle,
      embeddedWorkflow,
      embeddedWorkflowStatus,
    });

  return {
    ...options,
    timeHorizons: workflowData.goalTimeHorizons,
    riskQuestions: workflowData.goalRiskQuestions,
    riskQuestionTitle,
    riskQuestionTitlePending,
  };
};
